import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "fallback-image" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modelValue.filePath && !_ctx.isImageError)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "fallback-image__img",
          src: _ctx.modelValue.filePath,
          onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imageError && _ctx.imageError(...args)))
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2))
      : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          size: "32"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icons.PictureFilled)))
          ]),
          _: 1 /* STABLE */
        }))
  ]))
}